import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Message, MessageGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}

export type IsLoading = Record<keyof typeof initialLoading, boolean>

const initialState: { value?: MessageGroup[], isLoading: IsLoading } = { isLoading: initialLoading }

const messageSlice = createSlice({
  name: "message_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Message>) => {
      if (!state.value) state.value = [{
        _id: action.payload.client!,
        count: 1,
        messages: [action.payload]
      }]
      else {
        const target_message_group = state.value.find(message_group => message_group._id === action.payload.client)
        if (
          target_message_group &&
          !target_message_group.messages.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(message_group => {
            if (message_group._id === target_message_group._id) return {
              ...target_message_group,
              count: target_message_group.count + 1,
              messages: [...target_message_group.messages, action.payload]
            }
            else return message_group
          })
        }
        if (!target_message_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.client!,
              count: 1,
              messages: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Message>) => {
      if (state.value) {
        const target_message_group = state.value.find(message_group => message_group._id === action.payload.client)
        if (target_message_group) {
          state.value = state.value.map(message_group => {
            if (message_group._id === target_message_group._id) return {
              ...target_message_group,
              count: target_message_group.count - 1,
              messages: target_message_group.messages.filter(message => message._id !== action.payload._id)
            }
            return message_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Message>) => {
      if (state.value) {
        const target_message_group = state.value.find(message_group => message_group._id === action.payload.client)
        if (target_message_group) {
          state.value = state.value.map(message_group => {
            if (message_group._id === target_message_group._id) return {
              ...target_message_group,
              messages: target_message_group.messages.map(message => message._id === action.payload._id ? action.payload : message)
            }
            return message_group
          })
        }
        else {
          state.value = state.value.map(message_group => ({
            ...message_group,
            messages: message_group.messages.filter(message => message._id !== action.payload._id)
          })).concat([{
            _id: action.payload.client!,
            count: 1,
            messages: [action.payload]
          }])
        }
      }
    },
    reset: (state, action: PayloadAction<MessageGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading  = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = messageSlice.actions

export const message_slice = messageSlice.reducer